package de.katoonerie.content

import androidx.compose.runtime.Composable
import de.katoonerie.components.ArrowPath
import org.jetbrains.compose.web.dom.Div

@Composable
fun Loading() {
    Div(attrs = {
        classes("my-24", "mx-auto", "w-32", "h-32", "animate-spin")
    }) {
        ArrowPath()
    }
}
